// extracted by mini-css-extract-plugin
export default {"label":"ControlLabel_label_A5JLk","indicator":"ControlLabel_indicator_Z4l6Q","dirty":"ControlLabel_dirty_XBHbS","icon":"ControlLabel_icon_v4sBx"};